import { createAction } from '@ngrx/store';
import { UserEntity } from 'src/app/models';


export const login = createAction('USER_LOGIN');
export const userData = createAction(
    'USER_DATA',
    (payload: UserEntity) => ({payload})
);
